<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)"></van-col>
                    <van-col span="12">
                        <div class="banner-title">好友列表</div>
                    </van-col>
                    <van-col span="6" @click="toFind">
                        <div class="find">发现</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content-body">
            <div class="new-add" @click="toApplyList">
                <div class="new-item">
                    <div class="img-box">

                    </div>
                    <img class="new-icon" src="@/assets/theme/light/share/04friendList/01new.png">
                    <div class="new-name">新的朋友</div>
                    <div class="new-num" v-if="applyCount > 0">
                        <van-badge :content="applyCount" max="99" color="#FF0101"/>
                    </div>
                </div>
            </div>
            <div class="friend-box">
                <div class="friend-item" v-for="item in friendList" @click="toFriendDesc(item)">
                    <img class="friend-icon" :src="item.userAvatar ? item.userAvatar : defaultImg">
                    <div class="friend-name">{{item.userName}}</div>
                </div>
                <div class="friend-count" v-show="friendCount > 0">共{{friendCount}}个好友</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'friendList',
        data() {
            return {
                theme: 'light',
                pageSize: 10,
                pageNum: 0,
                friendList: [],
                isLoading: false,
                defaultImg: require('@/assets/share/home/noImg.png'),
                applyCount: 0,
                friendCount: 0
            }
        },
        mounted() {
            if (this.$route.query.theme) {
                this.theme = this.$route.query.theme
            }
            this.getFriendList();
        },
        methods: {
            back() {
                this.$router.back();
            },
            toFind() {
                this.$router.push({
                    name: 'findLight',
                    query: {
                        theme: this.theme
                    }
                })
            },
            getFriendList() {
                this.pageNum++;
                this.isLoading = true;
                this.$api.share.getFriendList({
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                }).then(res => {
                    this.applyCount = res.info.applyCount
                    this.friendCount = res.info.friends.count
                    this.friendList.push(...res.info.friends.items);
                    this.isLoading = false;
                })
            },
            // 滚动回调函数
            scrollHande() {
                // 节流
                if (this.isLoading) return
                // 获取内容高度
                var scrollH = document.documentElement.scrollHeight
                // 获取窗口高度
                var innerH = window.innerHeight
                // 获取滚出去的内容高度
                var top = document.body.scrollTop || document.documentElement.scrollTop
                // 当内容还剩余200的高度未滚出的时候发送请求
                if (scrollH - top - innerH < 200) {
                    // 发送请求
                    this.getDynamicsList();
                }
            },
            // 绑定scroll事件
            bindScroll() {
                window.addEventListener('scroll', this.scrollHande)
            },
            // 清除scroll事件
            clearScroll() {
                window.removeEventListener('scroll', this.scrollHande)
            },
            toApplyList() {
                this.$router.push({
                    name: 'applyListLight',
                    query: {
                        theme: this.theme
                    }
                })
            },
            toFriendDesc(item) {
                localStorage.setItem('sharerId', item.userId);
                this.$router.push({
                    name: 'friendDescLight',
                    query: {
                        theme: this.theme
                    }
                })
            }
        },
        // 页面销毁之前，清除scroll
        destroyed() {
            this.clearScroll()
        }
    }
</script>

<style scoped>

    .friend-item {

    }

    .friend-icon {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        margin-left: 37px;
        margin-top: 15px;
        margin-bottom: 15px;
        vertical-align: bottom;
    }

    .friend-name {
        color: var(--text-color-1);
        font-size: 14px;
        display: inline-block;
        line-height: 44px;
        margin-left: 8px;
        margin-top: 15px;
        margin-bottom: 15px;
    }

    .new-add {
        height: 66px;
        width: 345px;
        margin: 15px auto 0;
        background: var(--bg-color-2);
        border-radius: 13px 13px 13px 13px;
    }

    .friend-count {
        color: var(--text-color-2);
        text-align: center;
        font-size: 15px;
        margin-bottom: 15px;
    }

    .new-icon {
        width: 44px;
        height: 44px;
        position: absolute;
        left: 22px;
        top: 13px;
    }

    .new-item {
        position: relative;
        height: 66px;
    }

    .new-num {
        position: absolute;
        right: 22px;
        top: 26px;
        display: inline-block;
        font-size: 12px;
    }

    .new-name {
        position: absolute;
        top: 23px;
        left: 77px;
        color: var(--text-color-1);
        font-size: 14px;
    }

    /deep/ .van-badge {
        border: none;
    }

    .find {
        color: #00BD9B;
        font-size: 14px;
        float: right;
        margin-top: 15px;
        margin-right: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/views/shareLight/04friendList.vue